import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Card, CardContent } from '@prisjakt/ui/card';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import ModalComponent from 'src/components/modal';

export const Wrapper = styled.div`
  background-color: ${p => p.theme.colors.maybeBlue100};
  padding: ${layout.measurements.spacing150} 0;
  display: flex;
  justify-content: center;

  ${media.smallOnly`
    padding: ${layout.measurements.spacing150};
    // Force wrapper to the edges of the screen
    margin-left: -${layout.measurements.spacing100};
    margin-right: -${layout.measurements.spacing100};
  `};
`;

export const Prompt = styled(Card)`
  background: ${p => p.theme.bg.primary};
  max-width: 500px;
  text-align: center;
`;

export const Content = styled(CardContent)`
  && {
    align-items: center;
  }
`;

export const Question = styled.div``;

export const SubmitButton = styled(PrimaryButton)`
  max-width: max-content;
  margin-left: auto;
`;

export const Modal = styled(ModalComponent)`
  && {
    padding: ${layout.measurements.spacing150};

    ${media.smallOnly`
      width: 100vw;
      max-width: 100vw;
      bottom: 0;
      margin: 0;
    `};
  }
`;

export const ThankYouWrapper = styled.div`
  text-align: center;
  margin-top: ${layout.measurements.spacing300};
`;

export const FeedbackPrompt = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
`;
